// extracted by mini-css-extract-plugin
export default {"cls1":"FeedbackModal-cls1___aa13576a41377af697d","cls2":"FeedbackModal-cls2___37b049c48b4f934d255 FeedbackModal-cls1___aa13576a41377af697d"};